import { render, staticRenderFns } from "./owlCarosel.vue?vue&type=template&id=81f48574&"
import script from "./owlCarosel.vue?vue&type=script&lang=js&"
export * from "./owlCarosel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports